export default __webpack_public_path__ + "static/media/card-verify.e4db14a1.webp";